/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusNewsDetailDto } from '../../models/lexplus-news-detail-dto';
import { LexplusUpdateNewsDto } from '../../models/lexplus-update-news-dto';

export interface NewsControllerUpdateV1$Params {
  id: number;
      body: LexplusUpdateNewsDto
}

export function newsControllerUpdateV1(http: HttpClient, rootUrl: string, params: NewsControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusNewsDetailDto>> {
  const rb = new RequestBuilder(rootUrl, newsControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusNewsDetailDto>;
    })
  );
}

newsControllerUpdateV1.PATH = '/v1/news/{id}';
